export function generateHostStoryUrl(story = {}) {
  return story.url;
}
